/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { translations } from 'src/constants/translations';
import { ButtonApp } from 'src/components/Button';
import { ICategory } from 'src/typings/complexes';
import { useGetAuthData } from 'src/hooks';
import { postBitrixStage } from 'src/api';
import { CRMNames, IntegrationType } from 'src/typings/app';
import { toUpperCase } from 'src/helpers/toUpperCase';
import { locals } from 'src/constants';
import { useStyles } from '../styles';

interface ICategoryModal {
  integration: IntegrationType
  isOpen: boolean;
  handleClose: Function;
  fecthStages: Function;
  onSubmitAction: (data: any) => void
  errorMessage: string;
}

const bitrixSchema = yup.object().shape({
  stageName: yup.string().required('Это обязательное поле'),
  stageId: yup.string().required('Это обязательное поле'),
});

const netHuntSchema = yup.object().shape({
  stageName: yup.string().required('Это обязательное поле'),
});

export const StageModal: React.FC<ICategoryModal> = ({
  integration, isOpen, handleClose, fecthStages, onSubmitAction, errorMessage,
}) => {
  const styles = useStyles({});
  const [error, setError] = useState(errorMessage);
  const { getJWT } = useGetAuthData();
  const jwt = getJWT();

  const {
    register, handleSubmit, formState, trigger,
  } = useForm({
    resolver: yupResolver(integration === CRMNames.netHunt ? netHuntSchema : bitrixSchema),
    mode: 'onChange',
  });

  const onSubmit = (data:any) => {
    onSubmitAction(data);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={styles.modalWindow}
      open={isOpen}
      onClose={() => handleClose()}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={isOpen}>
        <Paper
          style={{
            outline: 'none',
          }}
        >
          <Box width="600px" maxHeight="90vh" overflow="auto" py={10} px={11}>
            <Box mb={6} fontSize="24px" fontWeight={600}>
              Adding a new Stage
            </Box>
            <Box fontSize="18px">
              <form onSubmit={handleSubmit(onSubmit)}>
                {integration !== CRMNames.netHunt && (
                  <Box mb={4} display="flex" flexDirection="column">
                    {`STAGE ID from ${integration.toUpperCase()}`}
                    <Box width="260px" mt={2}>
                      <TextField
                        id="stageId"
                        variant="outlined"
                        name="stageId"
                        inputRef={register}
                      />
                    </Box>
                  </Box>
                )}
                <Box mb={4} display="flex" flexDirection="column">
                  {`STAGE  NAME from ${integration.toUpperCase()}`}
                  <Box width="260px" mt={2}>
                    <TextField
                      id="stageName"
                      variant="outlined"
                      name="stageName"
                      inputRef={register}
                    />
                  </Box>
                </Box>
                <Box width="260px">
                  <ButtonApp
                    text={translations.saveChanges}
                    color="primary"
                    variant="contained"
                    type="submit"
                    className={styles.btn}
                    disabled={!formState.isValid}
                  />
                </Box>
              </form>
              <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError('')}>
                <Alert onClose={() => setError('')} elevation={6} variant="filled" severity="error">
                  {error}
                </Alert>
              </Snackbar>
            </Box>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};
